export default __webpack_public_path__ + "static/media/logo-text-white.a33d47ec.png";